export const events = {
  eventsCardDurationText: 'Duración',
  eventsSearchInputText: 'Buscar',
  eventsRegisteredToEventAlertTitle: 'Registrado exitosamente',
  eventsUnregisteredToEventAlertTitle: 'Desregistrado exitosamente',
  eventsExternalRegistrationPopupTitle: 'Registrarse',
  eventsExternalRegistrationPopupContent: '¿Te has registrado exitosamente?',
  eventsExternalRegistrationNoButtonTitle: 'No',
  eventsExternalRegistrationYesButtonTitle: 'Sí',
  eventsCurtainCopyOptionTitle: 'Copiar enlace',
  eventsCurtainFlagOptionTitle: 'Reportar contenido',
  eventsLinkCopiedAlertText: 'Enlace copiado!',
  eventsCurtainAddToCalendOptionTitle: 'Agregar al calendario',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'En el mapa',
  eventdetailsOnlineLocationTitle: 'En línea',
  eventdetailAmountsRegisteredText: 'Asistentes',
  eventdetailsSeeAllButtonTitle: 'Ver todos',
  eventdetailsRegisteredButtonTitle: 'Registrarse',
  eventdetailsRegisterButtonTitle: 'Registrarse',
  eventdetailsRegisteredAlertText: 'Registrado exitosamente',
  eventdetailsUnregisteredAlertText: 'Desregistrado exitosamente',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Usuarios registrados',
  eventdetailsSpeakersCurtainTitle: 'Oradores',
  eventdetailsSpeakersSectionTitle: 'Oradores',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Ver todos',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Ver todos',
  eventdetailsCurtainCopyOptionTitle: 'Copiar enlace',
  eventdetailsCurtainFlagOptionTitle: 'Reportar contenido',
  eventsdetailsLinkCopiedAlertText: 'Enlace copiado!',
  eventdetailsCurtainAddToCalOptionTitle: 'Agregar al calendario',
  eventDetailsAddCalendarPopupTitle: 'Calendario',
  eventdetailsAddCalendarPopupContent: '¿Agregar al calendario?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'No',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Sí',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Copiar enlace',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Reportar contenido',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Enlace copiado!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Copiar enlace',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Reportar contenido',
  eventsFlag: 'Reportar',
  eventsJoin: 'Unirse',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Enlace copiado!',
  eventContentReported: 'Contenido reportado',
  eventsError: '¡Algo salió mal!',
  eventdetailsExternalRegistrationPopupContent: '¿Te has registrado exitosamente?',
  eventdetailsExternalRegistrationNoButtonTitle: 'No',
  eventdetailsExternalRegistrationYesButtonTitle: 'Sí',
  eventdetailsExternalRegistrationPopupTitle: 'Registrarse',
  eventsCardRegisteredButtonTitle: 'Registrados',
  eventsCardRegisterButtonTitle: 'Registrarse',
  eventsJoinLink: 'Enlace para unirse: [url]{link}[/url][br]',
  eventsGuest: 'Invitado',
  eventsNoSessionInDay: 'No hay eventos este día.',
  eventsShowUpcomingEvent: 'Mostrar próximo evento'
}
